import Drawer from '@material-ui/core/Drawer';
import { makeStyles, Theme } from '@material-ui/core/styles';
import cx from 'classnames';
import React, { useRef, useState } from 'react';

interface IProps {
  shrink: boolean;
  children: React.ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '.MuiCollapse-container': {
      display: 'none',
    },
  },
  shrinkDrawer: {
    width: theme.spacing(7) + 1,
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
  },
}));

export default function MiniVariantDrawer(props: IProps): JSX.Element {
  const classes = useStyles();

  const { shrink, children, onMouseEnter, onMouseLeave } = props;
  const tId = useRef<NodeJS.Timeout>();

  const [open, isOpen] = useState<boolean>(false);

  const handleMouseEnter = () => {
    if (!shrink) {
      return;
    }

    if (tId.current) {
      clearTimeout(tId.current);
    }

    tId.current = setTimeout(() => {
      typeof onMouseEnter === 'function' && onMouseEnter();
      isOpen(true);
    }, 200);
  };

  const handleMouseLeave = () => {
    if (!shrink) {
      return;
    }

    typeof onMouseLeave === 'function' && onMouseLeave();
    isOpen(false);
  };

  return (
    <nav className={cx(classes.drawer, { [classes.shrinkDrawer]: shrink })}>
      <Drawer
        variant="permanent"
        className={cx(classes.drawer, {
          [classes.drawerOpen]: !shrink || open,
          [classes.drawerClose]: shrink && !open,
        })}
        classes={{
          paper: cx({
            [classes.drawerOpen]: !shrink || open,
            [classes.drawerClose]: shrink && !open,
          }),
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Drawer>
    </nav>
  );
}
